export default __webpack_public_path__ + "static/media/2.2001c1c3.jpg";